// Vendor logos for model pickers, from @lobehub/icons-static-svg (MIT, no
// runtime deps, pinned to an exact version). Inlined as SVG markup so mono
// marks follow the text color in both themes. Keyed by the slug prefix
// ("anthropic" in "anthropic/claude-…").
import aws from "@lobehub/icons-static-svg/icons/aws-color.svg?raw";
import azure from "@lobehub/icons-static-svg/icons/azure-color.svg?raw";
import claude from "@lobehub/icons-static-svg/icons/claude-color.svg?raw";
import deepseek from "@lobehub/icons-static-svg/icons/deepseek-color.svg?raw";
import fireworks from "@lobehub/icons-static-svg/icons/fireworks-color.svg?raw";
import gemini from "@lobehub/icons-static-svg/icons/gemini-color.svg?raw";
import googlecloud from "@lobehub/icons-static-svg/icons/googlecloud-color.svg?raw";
import groq from "@lobehub/icons-static-svg/icons/groq.svg?raw";
import huggingface from "@lobehub/icons-static-svg/icons/huggingface-color.svg?raw";
import kimi from "@lobehub/icons-static-svg/icons/kimi-color.svg?raw";
import lmstudio from "@lobehub/icons-static-svg/icons/lmstudio.svg?raw";
import minimax from "@lobehub/icons-static-svg/icons/minimax-color.svg?raw";
import mistral from "@lobehub/icons-static-svg/icons/mistral-color.svg?raw";
import nvidia from "@lobehub/icons-static-svg/icons/nvidia-color.svg?raw";
import ollama from "@lobehub/icons-static-svg/icons/ollama.svg?raw";
import openai from "@lobehub/icons-static-svg/icons/openai.svg?raw";
import openrouter from "@lobehub/icons-static-svg/icons/openrouter.svg?raw";
import qwen from "@lobehub/icons-static-svg/icons/qwen-color.svg?raw";
import together from "@lobehub/icons-static-svg/icons/together-color.svg?raw";
import vllm from "@lobehub/icons-static-svg/icons/vllm-color.svg?raw";
import voyage from "@lobehub/icons-static-svg/icons/voyage-color.svg?raw";
import xai from "@lobehub/icons-static-svg/icons/xai.svg?raw";
import zhipu from "@lobehub/icons-static-svg/icons/zhipu-color.svg?raw";
import type { EndpointKind } from "./endpoint-kind";
import { whiteToCurrentColor } from "./svg-utils";

export { endpointKind, type EndpointKind } from "./endpoint-kind";

// The <title> would show as a native tooltip on hover; the label is beside it.
const clean = (svg: string) => svg.replace(/<title>.*?<\/title>/, "");

export const VENDOR_LOGOS: Record<string, string> = {
  anthropic: clean(claude),
  openai: clean(openai),
  google: clean(gemini),
  deepseek: clean(deepseek),
  // The color mark draws its "K" in white for a dark backdrop; on our neutral
  // tile it must follow the text color or only the blue dot shows.
  moonshotai: whiteToCurrentColor(clean(kimi)),
  minimax: clean(minimax),
  qwen: clean(qwen),
  "x-ai": clean(xai),
  "z-ai": clean(zhipu),
  voyage: clean(voyage),
};

// Services people add themselves, by the kind endpointKind finds.
export const ENDPOINT_LOGOS = {
  azure: clean(azure),
  bedrock: clean(aws),
  vertex: clean(googlecloud),
  openai: clean(openai),
  mistral: clean(mistral),
  openrouter: clean(openrouter),
  together: clean(together),
  groq: clean(groq),
  fireworks: clean(fireworks),
  huggingface: clean(huggingface),
  nvidia: clean(nvidia),
  ollama: clean(ollama),
  vllm: clean(vllm),
  lmstudio: clean(lmstudio),
} as const satisfies Record<EndpointKind, string>;
